import { useState } from 'react';
import { GOLD_DATA } from '../../common/types';
import {
  INITIAL_COUNT,
  FIRST_EXPAND_COUNT,
  SUBSEQUENT_EXPAND_COUNT,
} from './constants';

interface UseCityComparisonParams {
  citiesData: GOLD_DATA[];
  metroCities: string[];
  city: string;
}

interface UseCityComparisonReturn {
  displayData: GOLD_DATA[];
  hasMore: boolean;
  handleViewMore: () => void;
  isEmpty: boolean;
}

export const useCityComparison = ({
  citiesData,
  metroCities,
  city,
}: UseCityComparisonParams): UseCityComparisonReturn => {
  const [visibleCount, setVisibleCount] = useState(INITIAL_COUNT);
  const [hasExpandedOnce, setHasExpandedOnce] = useState(false);

  const cityLower = city.toLowerCase();
  const filtered = citiesData
    .filter((d) => d.city.toLowerCase() !== cityLower)
    .sort((a, b) => a.city.localeCompare(b.city));

  const metroData = filtered.filter((d) =>
    metroCities.some((c) => c.toLowerCase() === d.city.toLowerCase())
  );

  const displayData = hasExpandedOnce
    ? filtered.slice(0, visibleCount)
    : metroData.slice(0, visibleCount);

  const hasMore = visibleCount < filtered.length;

  const handleViewMore = () => {
    if (!hasExpandedOnce) {
      setHasExpandedOnce(true);
      setVisibleCount(FIRST_EXPAND_COUNT);
    } else {
      setVisibleCount((prev) =>
        Math.min(prev + SUBSEQUENT_EXPAND_COUNT, filtered.length)
      );
    }
  };

  const isEmpty = !citiesData || citiesData.length === 0;

  return { displayData, hasMore, handleViewMore, isEmpty };
};
